<template>
  <div class="newton-header">
    <v-row
      no-gutters
      align="center"
      class="newton-header__row"
    >
      <v-col />

      <v-col
        cols="auto"
        class="newton-header__text-col"
      >
        <span class="newton-header__text">
          Try out Newton, our AI expert!
        </span>
      </v-col>

      <v-col cols="auto">
        <newton-button />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NewtonButton from '@/ai/components/NewtonButton'

export default {
  name: 'AppNewtonHeader',

  components: {
    NewtonButton
  }
}
</script>

<style scoped>
.newton-header {
  width: 100%;
  height: 56px;
  padding: 0 16px;

  background-color: #11224e;
  flex-shrink: 0;
}

.newton-header__row {
  width: 100%;
  height: 100%;
  min-width: 0;
}

.newton-header__text-col {
  min-width: 0;
  margin-right: 16px;
}

.newton-header__text {
  color: rgba(255, 255, 255, 0.65);
  font-size: 14px;
  white-space: nowrap;
}
</style>
